// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"55520036","186":"212ee684","272":"36ff40c2","372":"9b5a2662","738":"ff8377e9","841":"bb6add0c","851":"dcf63fa4","856":"b0044aa2"}[chunkId] + ".chunk.js";
};